import { createInlineNestedAppAuthBridge } from "./inlineNestedAppAuthBridge";
import { isHosted } from "owa-config";
import isNestedAppAuthAvailable from "../isNestedAppAuthAvailable";

export function initializeInlineNestedAppAuthBridge(targetWindow?: Window): void {
    if (!isHosted() && isNestedAppAuthAvailable()) {
        createInlineNestedAppAuthBridge(targetWindow);
    }
}
